import React from "react";

export const About = () => {
	return (
		<>
			<p>
				Thanks for using the Gloomhaven Item Database. If you find any
				issues with the content or bugs with the db you can{" "}
				<a
					href="https://github.com/heisch/gloomhaven-item-db/issues"
					target="_blank"
					rel="noreferrer"
				>
					report issues here
				</a>
				.
			</p>
		</>
	);
};
